import { useMemo } from 'react';
import { StatCard, StatCardGrid } from '../../../components/common';
import { fmtCurrency } from '../../../utils/formatNumber';
import { formatDate } from '../../../utils/dateUtils';
import styles from '../Reports.module.css';

const ENTRY_TYPE_LABELS = {
  offering:          'Offering Receipt',
  payment:           'Receipt',
  expense:           'Payment',
  asset_transfer:    'Asset Transfer',
  opening_balance:   'Opening Balance',
  adjustment:        'Adjustment',
  reversal:          'Reversal',
  loan_received:     'Loan Received',
  loan_repayment:    'Loan Repayment',
  loan_given:        'Loan Given',
  asset_purchase:    'Asset Purchase',
  fund_transfer:     'Fund Transfer',
  cash_deposit:      'Cash Deposit',
  cash_withdrawal:   'Cash Withdrawal',
  donation_transfer: 'Donation Transfer',
};

const typeLabel = (t) => ENTRY_TYPE_LABELS[t] || t;

export default function DayBookReport({ data, filterType = '' }) {
  const rows = data?.rows || [];

  const filteredRows = useMemo(
    () => (filterType ? rows.filter((r) => r.entryType === filterType) : rows),
    [rows, filterType]
  );

  if (!data) return null;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <StatCardGrid cols={3}>
        <StatCard label="Total Receipts" value={fmtCurrency(data.summary?.totalReceipts)} valueColor="green" />
        <StatCard label="Total Payments" value={fmtCurrency(data.summary?.totalPayments)} valueColor="red" />
        <StatCard label="Net"            value={fmtCurrency(data.summary?.net)} />
      </StatCardGrid>

      <div className="card">
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Voucher No</th>
                <th>Type</th>
                <th>Ledger Account</th>
                <th className={styles.amtRight}>Debit (₹)</th>
                <th className={styles.amtRight}>Credit (₹)</th>
                <th>Narration</th>
              </tr>
            </thead>
            <tbody>
              {filteredRows.length === 0 && (
                <tr><td colSpan={7} className="empty-state">No transactions found for this period.</td></tr>
              )}
              {filteredRows.map((r, i) => {
                const isNewEntry = i === 0 || filteredRows[i - 1].journalEntryId !== r.journalEntryId;
                return (
                  <tr
                    key={i}
                    style={isNewEntry && i > 0 ? { borderTop: '2px solid var(--color-border)' } : {}}
                  >
                    <td style={{ whiteSpace: 'nowrap' }}>{formatDate(r.entryDate)}</td>
                    <td><code>{r.voucherNo}</code></td>
                    <td style={{ whiteSpace: 'nowrap' }}>{typeLabel(r.entryType)}</td>
                    <td>{r.ledgerName}</td>
                    <td className={styles.amtRight}>
                      {Number(r.debitAmount) > 0 ? fmtCurrency(r.debitAmount) : '—'}
                    </td>
                    <td className={styles.amtRight}>
                      {Number(r.creditAmount) > 0 ? fmtCurrency(r.creditAmount) : '—'}
                    </td>
                    <td style={{ color: 'var(--color-text-muted)', fontSize: '0.85rem' }}>
                      {r.narration || ''}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
